export enum SwapCategory {    
    MatchOffer = 1,
    PendingCrossMatch = 2,
    CrossMatch = 3,
    PendingTransplant = 4,
    RemoteDonor = 5
}